import React from 'react';
import { ChevronDown } from 'lucide-react';
import LandingSection from './LandingSection';
import Reveal from './Reveal';
import { useT } from './i18n';

const LandingFaq = () => {
  const t = useT();
  const faqs = t('faq.items');
  return (
  <LandingSection id="faq" variant="gray" size="compact">
    <Reveal>
      <h2 className="landing-h2 landing-text-center" style={{ marginBottom: '2rem' }}>
        {t('faq.title')}
      </h2>
    </Reveal>
    <div className="landing-faq">
      {faqs.map((item, index) => (
        <Reveal key={item.q} delay={index * 0.06}>
          <details className="landing-faq__item">
            <summary className="landing-faq__q">
              {item.q}
              <ChevronDown size={18} className="landing-faq__chevron" aria-hidden />
            </summary>
            <p className="landing-faq__a">{item.a}</p>
          </details>
        </Reveal>
      ))}
    </div>
  </LandingSection>
  );
};

export default LandingFaq;
